import * as Yup from "yup";
import { PHRASE_REQUIRED, TRACKER_REQUIRED } from "../../helpers/validation.messages";

export const AddTrackerSchema = Yup.object({
    tracker: Yup.string().required(TRACKER_REQUIRED).trim(),
});

export const AddPhraseSchema = Yup.object({
    phrase: Yup.string().required(PHRASE_REQUIRED).trim(),
});